export default __webpack_public_path__ + "static/media/skirmishers_blade.b2efa539.jpg";